(() => {
  document.querySelectorAll('[data-tl-category-select]').forEach((select) => {
    select.addEventListener('change', () => {
      if (select.value) {
        window.location.href = select.value;
      }
    });
  });

  const targets = [
    '.template-index .shopify-section',
    '.template-index .card-wrapper',
    '.premium-testimonials__card'
  ];

  const elements = document.querySelectorAll(targets.join(','));

  if (!elements.length) {
    return;
  }

  if (!('IntersectionObserver' in window) || window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    elements.forEach((element) => element.classList.add('is-visible'));
    return;
  }

  elements.forEach((element) => element.classList.add('tl-reveal'));

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }
      });
    },
    { rootMargin: '0px 0px -8% 0px', threshold: 0.12 }
  );

  elements.forEach((element) => observer.observe(element));
})();
